<template>
    <div
        class="d-inline-flex align-items-center flex-nowrap ps-1"
        v-if="(value ?? '') !== ''"
    >
        <InputBool
            v-model="UseExternalEMITID"
            class="me-2"
        />
        {{ emitId }}
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type { RaceContestantDetailsExternalData } from '@/objects/RaceContestantDetailsExternalData';
import InputBool from '../Basic/InputBool.vue';
import WellKnown from '@/objects/generated/static/WellKnown';
import { useContestantStoreRef } from '@/stores';

const props = defineProps<{
    /**
     * This is the category name from the source
     */
    value: string | null;

    /**
     * The full row object
     */
    row: RaceContestantDetailsExternalData;
}>();

const { Contestants } = useContestantStoreRef();

const internalValue = ref<RaceContestantDetailsExternalData>(props.row);

// we need a writable computed for the internalvalue.UseExternalEMITID
const UseExternalEMITID = computed({
    get: () => !internalValue.value.UseExternalEMITID,
    set: (value: boolean) => {
        internalValue.value.UseExternalEMITID = !value;
    },
});

const emitId = computed(() => {
    if (!props.value) return '';

    const existingContestant = Contestants.value.find((c) => c.ISonenID === internalValue.value.RaceContestantDetails.ISonenID);

    return existingContestant?.ParticipantIDs.find((id) => id.ParticipantIDTypeID == WellKnown.IDTYPE_EMIT)?.Value ?? '';
});
</script>
